/**
 * Returns true when `nowMs` is within `windowMs` of `previousPressAtMs`.
 */
export function shouldTriggerSquadTvDoublePress(
  previousPressAtMs: number | null,
  nowMs: number,
  windowMs: number,
): boolean {
  if (previousPressAtMs == null) {
    return false;
  }
  return nowMs - previousPressAtMs <= windowMs;
}
